import { actionTypes as formActions, reducer as formReducer } from 'redux-form';

import actions from 'actions';
import { ESTIMA_FORM, LOGIN_INPUT_PREFIX, SIGNUP_SUCCEEDED } from 'constants/Global';

import { apiToForm, commonFormPlugin, isPhoneRequired } from './common';

/**
 * Redux form plugin
 * @param {Object} state
 * @param {Object} action
 * @return {Object} new state
 */
function estimaFormPlugin(state, action) {
    const commonState = commonFormPlugin(state, action);
    switch (action.type) {
        case formActions.CHANGE:
        case formActions.BLUR:
            if (action.meta.field === 'floor' && action.payload > commonState.values.floor_count) {
                return {
                    ...commonState,
                    values: { ...commonState.values, floor_count: action.payload },
                };
            }

            if (
                !commonState.values.user_profile &&
                action.meta.field === 'user_is_pro' &&
                action.payload === true
            ) {
                return {
                    ...commonState,
                    values: {
                        ...commonState.values,
                        [`${LOGIN_INPUT_PREFIX}is_pro`]: true,
                        user_profile: commonState.values.user_profile || 'USER_PROFILE.REALTOR',
                        [`${LOGIN_INPUT_PREFIX}profile_realtor_position`]:
                            commonState.values.user_profile_realtor_positions || '__None',
                        _phoneRequired: isPhoneRequired(commonState.values),
                    },
                };
            }

            if (action.meta.field === 'user_is_pro') {
                return {
                    ...commonState,
                    values: {
                        ...commonState.values,
                        [`${LOGIN_INPUT_PREFIX}is_pro`]: action.payload ? true : '',
                        _phoneRequired: isPhoneRequired(commonState.values),
                    },
                };
            }

            if (action.meta.field === 'user_profile') {
                return {
                    ...commonState,
                    values: {
                        ...commonState.values,
                        [`${LOGIN_INPUT_PREFIX}profile`]: action.payload,
                    },
                };
            }

            if (action.meta.field === 'user_profile_realtor_positions') {
                return {
                    ...commonState,
                    values: {
                        ...commonState.values,
                        [`${LOGIN_INPUT_PREFIX}profile_realtor_position`]: action.payload,
                    },
                };
            }

            if (action.meta.field === 'user_phone') {
                return {
                    ...commonState,
                    values: {
                        ...commonState.values,
                        [`${LOGIN_INPUT_PREFIX}cell_phone`]: action.payload,
                        [`${LOGIN_INPUT_PREFIX}profile_optin_realtors`]: !/\S/.test(action.payload),
                        _phoneRequired: isPhoneRequired(commonState.values),
                    },
                };
            }

            if (action.meta.field === 'profile_optin_realtors') {
                return {
                    ...commonState,
                    values: {
                        ...commonState.values,
                        [`${LOGIN_INPUT_PREFIX}profile_optin_realtors`]: action.payload,
                        _phoneRequired: isPhoneRequired(commonState.values),
                    },
                };
            }

            if (action.meta.field === 'profile_owner') {
                return {
                    ...commonState,
                    values: {
                        ...commonState.values,
                        _phoneRequired: isPhoneRequired(commonState.values),
                    },
                };
            }

            if (action.meta.field === 'coordinates') {
                return {
                    ...commonState,
                    values: {
                        ...commonState.values,
                        [`${LOGIN_INPUT_PREFIX}coordinates`]: action.payload,
                    },
                };
            }

            return commonState;
        case actions.RECEIVED_GET_ESTIMA:
            return apiToForm(commonState, action.estima);
        case actions.RECEIVED_SIGNUP:
            return {
                ...commonState,
                values: {
                    ...commonState.values,
                    [SIGNUP_SUCCEEDED]: true,
                },
            };
        case actions.SAVE_ESTIMA_ID:
            return {
                ...commonState,
                values: { ...commonState.values, _created_habitation_id: action.habitationId },
            };
        case actions.ADD_FIELD_HINT:
            return {
                ...commonState,
                hints: { ...commonState.hints, [action.field]: action.hint },
            };
        case actions.REMOVE_FIELD_HINT:
            return {
                ...commonState,
                hints: { ...commonState.hints, [action.field]: undefined },
            };
        case actions.RECEIVED_CHECK_ZONE_MEDIA:
            return {
                ...commonState,
                values: {
                    ...commonState.values,
                    _zoneMedia: action.isZoneMedia,
                    _phoneRequired: action.isPhoneRequired,
                },
            };

        default:
            return commonState;
    }
}

export default formReducer.plugin({
    [ESTIMA_FORM]: estimaFormPlugin,
});
